<ng-container *ngIf="isOpen">
    <div #popOver class="pop-over-background overflow-hidden" (click)="onOutsideClick($event, content)">
        <div #content class="content-container overflow-y-auto overflow-hidden scrollbar-thin" [ngClass]="{
            'emerge-from-right justify-right': position === 'right',
            'emerge-from-top items-start': position === 'top',
            'emerge-from-left justify-left': position === 'left', 
            'emerge-from-center items-center': position === 'center',
            'justify-center': ['top', 'center'].includes(position)
        }">
            <ng-content>

            </ng-content>

        </div>
    </div>
</ng-container>